import { AxiosResponse } from "axios";
import { SlotCreationBodyType } from "reducers/types/slotCreation";
import { SlotsRequestParamsType } from "reducers/types/slots";
import {
  SlotDetailType,
  SlotDetailUpdateBody,
  SlotDetailUpdateResponse,
  UserSlotType,
  PickersSlotRequestType,
  UserSlotRequestType,
  UsersSlotResponseType,
} from "sagas/types/slotDetailModal";
import { SlotCreationResponseType } from "sagas/types/slotCreation";
import {
  SlotBulkDeleteResponse,
  SlotsResponseType,
  StatusResponseType,
} from "sagas/types/slots";
import * as API from "./api";
import { TemplateCreationBodyType } from "reducers/types/slotTemplateModal";
import {
  TemplatesConfigResponseType,
  TemplatesCreationErrorResponseType,
  TemplatesCreationResponseType,
  SlotTemplatesDetailType,
  SlotTemplateType,
} from "sagas/types/slotTemplates";
import { SlotsTemplatesRequestParamsType } from "reducers/types/slotTemplates";

export const getStatus = (): Promise<
  AxiosResponse<API.ApiResponse<StatusResponseType>>
> => API.get(`/ms-admin-rest/api/v1.0/slots/status`);

export const getSlots = (
  params: SlotsRequestParamsType
): Promise<AxiosResponse<SlotsResponseType>> =>
  API.get("/ms-admin-rest/api/v1.0/slots", params);

export const validatePicker = (
  slotId: number,
  pickerId: number
): Promise<AxiosResponse<API.ApiResponseResult<UserSlotType>>> =>
  API.get(
    `/ms-admin-rest/api/v1.0/slots/${slotId}/pickers/${pickerId}/check-availability`
  );

export const deletePicker = ({
  slotId,
  pickerId,
}: UserSlotRequestType): Promise<AxiosResponse<null>> =>
  API.remove(`/ms-admin-rest/api/v1.0/slots/${slotId}/pickers/${pickerId}`);

export const addNewPicker = ({
  slotId,
  pickerId,
}: UserSlotRequestType): Promise<AxiosResponse<API.ApiResponseResult>> =>
  API.post(`/ms-admin-rest/api/v1.0/slots/${slotId}/pickers/${pickerId}`, {});

export const getPickers = (
  request: PickersSlotRequestType
): Promise<AxiosResponse<API.ApiResponseResult<UsersSlotResponseType>>> => {
  const { slotId, ...params } = request;
  return API.get(`/ms-admin-rest/api/v1.0/slots/${slotId}/pickers`, params);
};
export const getSlotDetail = (
  id: number
): Promise<AxiosResponse<SlotDetailType>> =>
  API.get(`/ms-admin-rest/api/v1.0/slots/${id}`);

export const updateSlot = (
  body: SlotDetailUpdateBody,
  regionId: string,
  id: number
): Promise<AxiosResponse<SlotDetailUpdateResponse>> =>
  API.put(`/ms-admin-rest/api/v1.0/slots/${id}`, body, {
    headers: { "x-region-uuid": regionId },
  });
export const createSlot = (
  body: SlotCreationBodyType
): Promise<AxiosResponse<SlotCreationResponseType & API.ErrorResponse>> =>
  API.post("/ms-admin-rest/api/v1.0/slots", body);

export const deleteSlot = (
  slotId: number
): Promise<AxiosResponse<API.ApiResponseResult<number>>> =>
  API.remove(`/ms-admin-rest/api/v1.0/slots/${slotId}`);

export const bulkDeleteSlot = (
  slots: number[]
): Promise<AxiosResponse<SlotBulkDeleteResponse>> =>
  API.post(`/ms-admin-rest/api/v1.0/slots/bulk-delete`, { slots });

export const getSlotTemplates = (
  params: SlotsTemplatesRequestParamsType
): Promise<AxiosResponse<API.ApiResponseGrid<SlotTemplateType>>> =>
  API.get("/ms-admin-rest/api/v1.0/templates", params);

export const getTemplateDetail = (
  id: number
): Promise<AxiosResponse<API.ApiResponseResult<SlotTemplatesDetailType>>> =>
  API.get(`/ms-admin-rest/api/v1.0/templates/${id}`);

export const createTemplate = (
  body: TemplateCreationBodyType
): Promise<
  AxiosResponse<
    API.ApiResponseResult<TemplatesCreationResponseType> &
      TemplatesCreationErrorResponseType
  >
> => API.post("/ms-admin-rest/api/v1.0/templates", body);

export const getTemplateConfig = (): Promise<
  AxiosResponse<API.ApiResponseResult<TemplatesConfigResponseType>>
> => API.get(`/ms-admin-rest/api/v1.0/templates/config`);

export const updateTemplate = (
  body: TemplateCreationBodyType,
  id: number
): Promise<
  AxiosResponse<
    API.ApiResponseResult<TemplatesCreationResponseType> &
      TemplatesCreationErrorResponseType
  >
> => API.put(`/ms-admin-rest/api/v1.0/templates/${id}`, body);
export const deleteTemplate = (
  id: number
): Promise<AxiosResponse<API.ApiResponseResult>> =>
  API.remove(`/ms-admin-rest/api/v1.0/templates/${id}`);

export const exportSlots = (
  params: SlotsRequestParamsType
): Promise<AxiosResponse<SlotsResponseType>> =>
  API.get("/ms-admin-rest/api/v1.0/slots.csv", params);
